import { getRegexFormatValidationRule } from './regex-format-validation-rule';
const dateRegexString = RegExp('^\\d{4}\\-(0[1-9]|1[012])\\-(0[1-9]|[12][0-9]|3[01])$');
export const dateFormatValidationRule = getRegexFormatValidationRule(dateRegexString);
